import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSocket } from '../../../shared/socket/useSocket';
import { commentsQueryKey } from './useComments';

// frontend-restructuring Fase 5.8 — extraído VERBATIM de `Comments.jsx` (era `useSocket` +
// `useQueryClient` directo en el componente presentacional). Sin cambio de comportamiento: los
// eventos de socket siguen actualizando la cache por `setQueryData` con el payload (patrón
// "echo": la mutación dispara, el backend emite el evento, esto lo refleja).
//
// TODO (05-remediation.md §5.8, follow-up): evaluar pasarlo a invalidation-first
// (`invalidateQueries` en vez de `setQueryData` del payload). Es un CAMBIO DE COMPORTAMIENTO
// (round-trip de refetch en vez de patch local) — commit aparte con before/after, no acá.
export function useCommentsSocketSync(docId) {
    const queryClient = useQueryClient();

    useSocket(useMemo(() => {
        const setComments = (updater) => {
            queryClient.setQueryData(commentsQueryKey(docId), (prev) => updater(prev ?? []));
        };

        return {
            comment_added: (newComment) => {
                if (String(newComment.document_id) === String(docId)) {
                    setComments(prev => {
                        if (prev.find(c => c.comment_id === newComment.comment_id)) return prev;
                        return [...prev, newComment];
                    });
                }
            },
            comment_updated: (updatedComment) => {
                if (String(updatedComment.document_id) !== String(docId)) return;
                setComments(prev => {
                    if (!prev.find(c => c.comment_id === updatedComment.comment_id)) return prev;
                    return prev.map(c => c.comment_id === updatedComment.comment_id ? { ...c, ...updatedComment } : c);
                });
            },
            comment_deleted: (data) => {
                setComments(prev => {
                    // Misma referencia de array si el comment_id no está — evita re-renders.
                    if (!prev.find(c => c.comment_id === data.comment_id)) return prev;
                    return prev.filter(c => c.comment_id !== data.comment_id);
                });
            },
        };
    }, [docId, queryClient]));
}
